/**
 * Booking config for the front app (patient / doctor / clinic).
 * See `config.admin.js` (in the admin Book folder) for the admin version.
 *
 * Every key is used by the shared Book flow. Keep both configs in the same shape.
 */
const frontBookConfig = {
  // ids used by the storage layer
  modelId: 'BookModel',
  accountModelId: 'AccountsModel',

  // method of BookModel that handles the `profile` event
  profileHandler: 'handleChangeProfileAndSwitchAccount',

  // API urls
  api: {
    doctorDetail: 'doctor/detail',
    appointmentDetail: 'appointment/detail',
    createAppointment: 'appointment/create',
    createAppointmentOffice: 'appointment/create/office',
    getSlots: 'schedule/listAvailable',
    getAvailableSlots: 'schedule/listAvailable',
    rescheduleAppointment: 'appointment/update',
    checkSlotAvailable: 'appointment/checkSlotAvailable',
    hospital: 'hospital/list',
    invitePatient: 'invitation/send/patient'
  },

  // props merged into the "Select a doctor" PopupSelect `apiConfig`
  doctorList: { url: 'clinic/doctor/list' },

  // turn the invite response into `{ id }` (or null on failure)
  parseInviteResult: (data) => (data?.ok ? { id: data.invitation.patientId } : null),

  // --- behaviour flags ---
  // Patients and doctors can open the flow too (not only clinic staff)
  roleBasedFlows: true,
  // "Pay now" toggle and redirect to the invoice page after saving
  payNowEnabled: true,
  // Scroll the slot calendar to the selected date after slots load
  scrollCalendarOnLoad: false,
  // After save: go back (true) or go to the appointments page (false)
  finishWithBack: false,

  // --- request builders (differences between front and admin API) ---
  // `partnerId` sent to checkSlotAvailable
  getSlotCheckPartnerId: ({ user, doctorId, patientId }) =>
    user?.isPatient ? doctorId : patientId,
  // `userId` sent to hospital/list
  getHospitalOwnerId: ({ doctor, doctorId }) =>
    doctor?.clinicIds?.length ? doctor.clinicIds[0] : doctorId,
  // extra params sent to the reschedule api
  getRescheduleExtraParams: () => ({})
};

export default frontBookConfig;
